import { AnsweringClient } from "../clients/answeringClient";

export interface SelfInviteControllerDelegate {
  inviteSuccess(): void;
  inviteFailed(): void;
  setRedirectingText(value: string | null): void;
}

export class SelfInviteController {
  constructor(
    private delegate: SelfInviteControllerDelegate,
    private client = new AnsweringClient()
  ){}

  public async registerInvite(token: string, accessToken: string) {
    this.delegate.setRedirectingText("Atualizando dados...");

    try {
      const result = await this.client.selfInvite(token, accessToken);

      if (Math.trunc(result.status/100) !== 2)
        return this.delegate.inviteFailed();

      this.delegate.inviteSuccess();
    } catch (error) {
      this.delegate.inviteFailed();
    }
  }
}
